import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'start-a-petition-v2',
		path: '/corgi/start-a-petition/:step',
		component: loadable(async () => import(/* webpackChunkName: "pages/start_a_petition-v2" */ './index'), {
			exportName: 'StartAPetition',
			fallback: Loading,
		}),
		frame: {
			header: true,
			footer: false,
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
		disableFullRerenderForParams: ['step'],
	},
];
